// These values will be replaced dynamically by cloudbuild.yaml when
// the build is run.
export const APP_VERSION = 'master';
export const COMMIT_SHA = '3b27a90903d359868f5649650845656a32fcdc98';
